import { render, staticRenderFns } from "./StarFooter.vue?vue&type=template&id=56a5abb5&scoped=true&"
import script from "./StarFooter.vue?vue&type=script&lang=js&"
export * from "./StarFooter.vue?vue&type=script&lang=js&"
import style0 from "./StarFooter.vue?vue&type=style&index=0&id=56a5abb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a5abb5",
  null
  
)

export default component.exports